<template>
<v-container fluid class="fullscreen">
  <v-row no-gutters>
    <v-col cols="12" md="12" class="pa-2">
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="12" md="3" class="px-2">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                v-model="fromMenu"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDateValue"
                    label="From Date"
                    prepend-icon="event"
                    hide-details
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="fromDate" @input="fromMenu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" class="px-2">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                v-model="toMenu"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDateValue"
                    label="To Date"
                    prepend-icon="event"
                    hide-details
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="toDate" @input="toMenu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="10" md="3" class="px-2 pt-3">
              <v-autocomplete
                prepend-icon="perm_contact_calendar"
                :items="onlineshoppingList"
                v-model="onlineshopping"
                label="Onlineshopping"
                item-text="name"
                return-object
                hide-details
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="2" md="3" class="pt-3 text-center text-md-left">
              <v-btn fab depressed small color="primary" @click="search">
                <v-icon>search</v-icon>
              </v-btn>
              <v-btn depressed fab small class="mx-1" color="primary" outlined>
                <v-icon>help</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" class="pa-2 pt-0">
      <v-card>
        <v-card-title class="pa-0">
          <v-row no-gutters>
            <v-col cols="12" md="4" class="py-4 px-3">Online Detail Statement</v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-col>
    <v-col
      v-if="onlineDetailStatementData.osReportList.length == 0"
      class="px-2 text-center"
      cols="12"
      md="12"
    >No data available</v-col>
    <v-col cols="12" class="pa-2 pt-0" v-else>
      <v-card>
        <v-card-text>
          <v-data-table
            :items="onlineDetailStatementData.osReportList"
            :headers="statementHeader"
            :items-per-page="10"
            class="elevation-0"
            dense
          >
            <template v-slot:item.opening="{ item }">
              <div v-if="item.opening > 0">{{ item.opening | defaultPaymentFormat}}</div>
              <div v-else style="color: red;">{{ item.opening | defaultPaymentFormat}}</div>
            </template>
            <template v-slot:item.debt="{ item }">
              <div>{{ item.debt | defaultPaymentFormat}}</div>
            </template>
            <template v-slot:item.itemValue="{ item }">
              <div>{{ item.itemValue | defaultPaymentFormat}}</div>
            </template>
            <template v-slot:item.toOs="{ item }">
              <div style="color: red;">{{ item.toOs | defaultPaymentFormat}}</div>
            </template>
            <template v-slot:item.fromOs="{ item }">
              <div>{{ item.fromOs | defaultPaymentFormat}}</div>
            </template>
            <template v-slot:item.balance="{ item }">
              <div
                v-if="item.balance<0"
                style="color: red;"
              >{{ item.balance | defaultPaymentFormat}}</div>
              <div v-else>{{ item.balance | defaultPaymentFormat}}</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  </v-container>
</template>
<script>
import onlineDetailStatementService from "../service/OnlineDetailStatementService";
import onlineshoppingService from "../service/OnlineshoppingService";
export default {
  mounted: function() {
    this.getAllOnlineshopping();
  },
  data() {
    return {
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date().toISOString().substr(0, 10),
      onlineDetailStatementData: {
        osReportList: [],
        totalDebt: 0,
        totaltoOs: 0,
        totalfromOs: 0,
        totalGateReceive: 0,
        totalGateAmount: 0
      },
      onlineshoppingList: [],
      datePickerType: "date",
      onlineshopping: {},
      dateType: "date",
      fromMenu: false,
      toMenu: false,
      statementHeader: [
        { text: "Date", value: "date" },
        { text: "Opening", value: "opening" },
        { text: "Debt", value: "debt" },
        { text: "Item Value", value: "itemValue" },
        { text: "Payment", value: "toOs" },
        { text: "Collect", value: "fromOs" },
        { text: "Receive From OS", value: "gateReceive" },
        { text: "Car Gate Charges", value: "gateAmount" },
        { text: "Balance", value: "balance" }
      ]
    };
  },
  methods: {
    search: function() {
      onlineDetailStatementService
        .getOnlineDetailStatementReport(
          this.fromDateValue,
          this.toDateValue,
          this.onlineshopping.osId
        )
        .then(data => {
          console.log(data);
          this.onlineDetailStatementData = {
            osReportList: [],
            totalDebt: 0,
            totaltoOs: 0,
            totalfromOs: 0,
            totalGateReceive: 0,
            totalGateAmount: 0
          };
          if (data.osReportList.length != 0) {
            this.onlineDetailStatementData = Object.assign({}, data);
            this.onlineDetailStatementData.osReportList.push({
              debt: data.totalDebt,
              toOs: data.totaltoOs,
              fromOs: data.totalfromOs,
              itemValue: data.totalItemValue,
              balance: data.totalBalance,
              gateReceive: data.totalGateReceive,
              gateAmount: data.totalGateAmount
            });
          }
        });
    },
    getAllOnlineshopping: function() {
      onlineshoppingService.getAllOnlineshopping().then(response => {
        this.onlineshoppingList.splice(0, this.onlineshoppingList.length);
        this.onlineshoppingList.push(...response);
        this.onlineshopping = response[0];
        this.search();
      });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.dateType == "date") {
        // const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      } else if (this.dateType == "month") {
        // const [year, month, day] = date.split("-");
        return `${month}-${year}`;
      } else {
        // const [year, month, day] = date.split("-");
        return `${year}`;
      }
    },
    formatDateUrl(date) {
      //if (!date) return null;
      if (this.dateType == "month") {
        const [month, year] = date.split("-");
        return `01-${month}-${year}`;
      } else if (this.dateType == "year") {
        const [year] = date.split("-");
        return `01-01-${year}`;
      }
      return date;
    }
  },
  computed: {
    toDateValue() {
      var toDatetemp = "";
      toDatetemp = this.formatDate(this.toDate);
      return toDatetemp;
    },
    fromDateValue() {
      var fromDatetemp = "";
      fromDatetemp = this.formatDate(this.fromDate);
      return fromDatetemp;
    }
  }
};
</script>
<style scoped>
.fullscreen {
  height: 92vh;
}
</style>